import { IRootState } from '../resources/interfaces'

export const getSelectedTab = (state: IRootState) =>
  state.developmentReducer.selectedTab
